import { Stack, Typography, useTheme } from '@mui/material';
import { SidePanelCaption } from 'src/components/SidePanelCaption';
import { GetStripeSubscriptionDetailsResponse } from 'src/graphql/entities/stripe-subscription-details';
import { SubscriptionDetailsSummary } from './subscription-details-summary';
import { SubscriptionScheduleTimeline } from './subscription-schedule-timeline';

export const SubscriptionDetailsPanel = ({
  subscriptionDetails,
}: {
  subscriptionDetails: GetStripeSubscriptionDetailsResponse | undefined;
}) => {
  const theme = useTheme();

  if (!subscriptionDetails) return null;

  const hasSchedulePhases = Boolean(subscriptionDetails.schedule?.phases.length);

  return (
    <Stack mt={theme.spacing(2)}>
      <SidePanelCaption py={1} mb={theme.spacing(1)}>
        Subscription Details
      </SidePanelCaption>

      <SubscriptionDetailsSummary subscriptionDetails={subscriptionDetails} />

      <SidePanelCaption paddingTop={2} mb={theme.spacing(1)}>
        Subscription Schedule
      </SidePanelCaption>

      {hasSchedulePhases || subscriptionDetails.paused ? (
        <SubscriptionScheduleTimeline
          schedule={subscriptionDetails.schedule}
          paused={subscriptionDetails.paused}
          resumesAt={subscriptionDetails.resumesAt}
        />
      ) : (
        <Typography variant="body2" color="text.secondary" pb={2}>
          No schedule
        </Typography>
      )}
    </Stack>
  );
};
